var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canedar",
    clipPath: "url(#clip0_109_4994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 6.58331C2 5.99394 2.26339 5.42871 2.73223 5.01196C3.20107 4.59521 3.83696 4.36108 4.5 4.36108H19.5C20.163 4.36108 20.7989 4.59521 21.2678 5.01196C21.7366 5.42871 22 5.99394 22 6.58331V19.9166C22 20.506 21.7366 21.0712 21.2678 21.488C20.7989 21.9047 20.163 22.1389 19.5 22.1389H4.5C3.83696 22.1389 3.20107 21.9047 2.73223 21.488C2.26339 21.0712 2 20.506 2 19.9166V6.58331Z",
    stroke: "#121B3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 1.86108V6.86108",
    stroke: "#121B3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 1.86108V6.86108",
    stroke: "#121B3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2 11.8611H22",
    stroke: "#121B3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_4994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.d9fac9fdadb5e2d8bc2f52f9612f5f12.svg";
export { ForwardRef as ReactComponent };